import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {classMap} from 'lit/directives/class-map.js';
import {repeat} from 'lit/directives/repeat.js';
import {when} from 'lit/directives/when.js';
import {choose} from 'lit/directives/choose.js';
import {connect} from 'pwa-helpers';
import {msg} from '@lit/localize';
import store from '../../../store';
import {LocationState} from '../../../slices/lightProfileSlice';
import {selectSolarDimmProfile} from '../../solarSelectors';

import {solarDimmProfileOptions} from '../../dimProfiles';

@customElement('visual-solar-profile')
export class VisualSolarProfile extends connect(store)(LitElement) {

	static styles = css`
		:host {
			display: flex;
			width: 100%;
			height: 100%;
			overflow: hidden;
		}
		.container {
			width: 100%;
			display: grid;
			grid-template-columns: 1fr 1fr 1fr;
			grid-gap: 50px;
			padding: 100px;
		}
		.profile {
			opacity: 0.3;
			transition: opacity 0.4s;
		}
		.profile .title {
			color: var(--color-widget-text);
			font: var(--font-specsheet-light);
		}
		.profile img {
			width: 100%;
			margin: auto;
		}
		.profile.active {
			opacity: 1;
		}

	`;

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}
	stateChanged(state) {
		this.state = state;
		this.lang = state.status.lang;
		this.region = state.status.region;
		this.translations = state.productData.translations;
		this.decisions = state.decisions.data;
		this.location = state.lightProfile.data.project.location;
		this.locationState = state.lightProfile.data.locationState;
		this.selectedProfile = selectSolarDimmProfile(state);
	}
	render() {
		const s = this.state;
		return html`
			<div class="container">
				${repeat(solarDimmProfileOptions, (profile) => profile,
					(profile) => html`
						<div class="profile ${classMap({active: profile.id === this.selectedProfile})}">
							<div class="title">${profile.label[this.lang]}</div>
							<img src="/line-assets/img/solar-${profile.id}.png"/>
						</div>
				`)}
			</div>
		`;
	}
}
